import React, { Fragment, useEffect } from "react";
import Header from "../../components/Header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import HrmPageHero from "./components/HrmPageHero";
import HrmIntroSection from "./components/HrmIntroSection";
import HrmAdvantagesSection from "./components/HrmAdvantagesSection";
import HrmHowItWorksSection from "./components/HrmHowItWorksSection";
import HrmRolesSection from "./components/HrmRolesSection";
import HrmModulesSection from "./components/HrmModulesSection";
import HrmPanelsSection from "./components/HrmPanelsSection";
import WdevTestimonials from "../WebDevelopmentPage/components/WdevTestimonials";
import HrmCtaBanner from "./components/HrmCtaBanner";
import "../WebDevelopmentPage/web-development.css";
import "../HospitalManagementPage/hospital-management.css";
import "./hrm.css";

const HrmPage: React.FC = () => {
  useEffect(() => {
    document.title = "HRM Software | WebTech Software Solutions Bangalore";
    const description =
      "WebTech develops Human Resource Management software in Bangalore — employee management, payroll, attendance, leave, recruitment, and performance in one platform.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);

  return (
    <Fragment>
      <div className="wdev-page inner-page hrm-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <HrmPageHero />
            <HrmIntroSection />
            <HrmAdvantagesSection />
            <HrmHowItWorksSection />
            <HrmRolesSection />
            <HrmModulesSection />
            <HrmPanelsSection />
            <WdevTestimonials />
            <HrmCtaBanner />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default HrmPage;
